import { render, staticRenderFns } from "./TransportPaymentNew.vue?vue&type=template&id=3007b1fb&scoped=true"
import script from "./TransportPaymentNew.vue?vue&type=script&lang=js"
export * from "./TransportPaymentNew.vue?vue&type=script&lang=js"
import style0 from "./TransportPaymentNew.vue?vue&type=style&index=0&id=3007b1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007b1fb",
  null
  
)

export default component.exports